import clsx from 'clsx';
import { useFormik } from 'formik';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/auth/useAuthContext';
import { Alert, KeenIcon } from '@/components';
import { useLayout } from '@/providers';
import { AxiosError } from 'axios';
import { useIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
const initialValues = {
  email: ''
};

const ResetPassword = () => {
  const intl = useIntl();
  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({ id: 'AUTH.ERROR.INVALID_EMAIL' }))
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN_LENGTH_EMAIL' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX_LENGTH_EMAIL' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRED_EMAIL' }))
  });
  const [loading, setLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState(undefined);
  const {
    // requestPasswordResetLink
  } = useAuthContext();
  const {
    currentLayout
  } = useLayout();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setHasErrors(undefined);
      // Không gọi API nữa, chuyển luôn sang trang kế tiếp
      setLoading(false);
      const params = new URLSearchParams();
      params.append('email', values.email);
      navigate({
        pathname: currentLayout?.name === 'auth-branded' ? '/auth/reset-password/enter-code' : '/auth/classic/reset-password/enter-code',
        search: params.toString()
      });
    }
  });
  return <div className="card max-w-[370px] w-full">
    <form className="card-body flex flex-col gap-5 p-10" noValidate onSubmit={formik.handleSubmit}>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900"><FormattedMessage id="AUTH.YOUR_EMAIL" /></h3>
        <span className="text-2sm text-gray-600 font-medium">
          <FormattedMessage id="AUTH.RESET_PASS.ENTEREMAIL" />
        </span>
      </div>

      {hasErrors && <Alert variant="danger">{formik.status}</Alert>}

      <div className="flex flex-col gap-1">
        <label className="form-label text-gray-900"><FormattedMessage id="AUTH.EMAIL" /></label>
        <label className="input">
          <input type="email" placeholder="email@email.com" autoComplete="off" {...formik.getFieldProps('email')} className={clsx('form-control bg-transparent', {
            'is-invalid': formik.touched.email && formik.errors.email
          }, {
            'is-valid': formik.touched.email && !formik.errors.email
          })} />
        </label>
        {formik.touched.email && formik.errors.email && <span role="alert" className="text-danger text-xs mt-1">
          {formik.errors.email}
        </span>}
      </div>

      <div className="flex flex-col gap-5 items-stretch">
        <button type="submit" className="btn btn-primary flex justify-center grow" disabled={loading || formik.isSubmitting}>
          {loading ? <FormattedMessage id="AUTH.PLEASE_WAIT" /> : <FormattedMessage id="AUTH.CONTINUE" />}
        </button>

        <Link to={currentLayout?.name === 'auth-branded' ? '/auth/login' : '/auth/classic/login'} className="flex items-center justify-center text-sm gap-2 text-gray-700 hover:text-primary">
          <KeenIcon icon="black-left" />
          <FormattedMessage id="AUTH.BACK_TO_LOGIN" />
        </Link>
      </div>
    </form>
  </div>;
};
export { ResetPassword };